export const modifierList = ['full', 'slim'];
